export const skills = {
  languages: ['PHP', 'SQL', 'JavaScript', 'TypeScript', 'CSS', 'HTML'],
  frameworks: ['Laravel', 'ReactJS', 'Redux', 'Express', 'Bootstrap'],
  databases: ['PostgreSQL', 'MongoDB'],
  others: ['SOLID', 'Clean Code', 'Testing', 'Git', 'Scrum', 'Photoshop'],
}
